import { mapFields } from "vuex-map-fields";

export const aprvalParam = {
  computed: {
    ...mapFields(["sessionInfo"]),
  },
  created() {
    this.subIdDsticCd = this.sessionInfo.userInfo.sbidDstcd; //SUBID구분코드
    this.mainWwwBnkgLginId = this.sessionInfo.userInfo.userIdnfr; //주인터넷뱅킹로그인ID
    this.wwwBnkgLginId = this.sessionInfo.userInfo.subUserIdnfr; //인터넷뱅킹로그인ID
    this.regiWwwBnkgLginId = this.sessionInfo.userInfo.sbidDstcd == "1" ? this.mainWwwBnkgLginId : this.sessionInfo.userInfo.subUserIdnfr; //등록인터넷뱅킹로그인ID
    this.groupCoCd = this.sessionInfo.cmgrCd; //그룹회사코드
    this.operGroupCd = this.sessionInfo.userInfo.operGroupCd; //운영그룹코드
    this.menuId = this.$route.path.split("/").slice(3, 4);
    this.menuName = this.$route.meta.parent;
  },
  data() {
    return {
      subIdDsticCd: "", //SUBID구분코드
      mainWwwBnkgLginId: "", //주인터넷뱅킹로그인ID
      wwwBnkgLginId: "", //인터넷뱅킹로그인ID
      regiWwwBnkgLginId: "", //등록인터넷뱅킹로그인ID
      groupCoCd: "", //그룹회사코드
      operGroupCd: "", //운영그룹코드
      menuId: "", //메뉴ID
      menuName: "", //메뉴명
    };
  },
};

/**
 * 결재상세보기 결과
 */
export const aprvalDetailResFn = {
  computed: {
    ...mapFields("admin/approvalInfo", ["RCA040DA40Response"]),
  },
  methods: {
    /**
     * 결재내역상세
     */
    RCA040DA40Suc(res) {
      const data = res.outItem;
      let tmp = [];
      let aprvalWaitID = ""; //결재 할 ID
      let isHoAprvalUser = false; //본사결재자 여부
      for (let i = 1; i < 5; i++) {
        let targetYn = "N";
        let prcssStusDstNm = "";
        let aprvalYmd = "";
        if (data[`prcssStusDstcd${i}`] == "0") {
          data[`yn${i}`] == "Y" ? (isHoAprvalUser = true) : (isHoAprvalUser = false);
          if (aprvalWaitID == "") {
            aprvalWaitID = data[`aprvalPsn${i}`];
            targetYn = "Y";
          }
          prcssStusDstNm = "PCOP-02-01-03-06"; //결재대기
        } else {
          prcssStusDstNm = "PCOP-02-02-04-03"; //결재완료
        }
        aprvalYmd = data[`aprvalYmd${i}`] ? this.$getGlobalDateFmt(this._.padEnd(data[`aprvalYmd${i}`], 20, " ")) : "";
        tmp.push({
          aprvalPnm: data[`aprvalPnm${i}`], //결재자명
          aprvalPsn: data[`aprvalPsn${i}`], //결재자명
          prcssStusDstNm, //처리상태구분명
          prcssStusDstcd: data[`prcssStusDstcd${i}`],
          aprvalYmd, //결재년월
          targetYn, //대상여부
          isHoAprvalUser, //본사여부
        });
      }
      // 결재 취소 나 영업일 마감일떄 상태 체크 start
      switch (data.lastPrcssStusDstcd) {
        case "31": //취소
        case "32": //취소
        case "33": //취소
          for (let i = 0; i < 4; i++) {
            if (i != 0 && data.aprvalPrgrsStgeNo == String(i)) {
              tmp[i].prcssStusDstNm = "34_결재처리상태구분코드";
            } else {
              tmp[i].prcssStusDstNm = "";
            }
            tmp[i].targetYn = "N"; //대상여부
          }
          break;
        case "42": //영업일마감취소
        case "43": //약정해지취소
        case "44": //사용자삭제취소
          for (let i = 0; i < 4; i++) {
            if (Number(data.aprvalPrgrsStgeNo) >= i) {
              tmp[i].prcssStusDstNm = data.lastPrcssStusDstcd + "_결재처리상태구분코드";
            } else {
              tmp[i].prcssStusDstNm = "";
            }
            tmp[i].targetYn = "N"; //대상여부
          }
          break;
      }
      //버튼 설정 관련 start
      let printBtn = false;
      let cancelBtn = false;
      let approvalBtn = false;
      let returnBtn = false;
      if (this.menuId == "history") {
        printBtn = true;
      } else {
        if (data.regiWWWBnkgLginID == this.regiWwwBnkgLginId && !"1" == tmp[0].prcssStusDstcd) {
          cancelBtn = true;
        } else {
          if (aprvalWaitID.trim() == this.regiWwwBnkgLginId) {
            if (!isHoAprvalUser) {
              approvalBtn = true;
              returnBtn = true;
            }
          }
        }
      }
      let RCA040DA40Res = {
        corpBzwkCd: data.corpBzwkCd,
        corpBzwkAprvalName: data.corpBzwkAprvalName,
        aprvalRegiCustnm: data.aprvalRegiCustnm,
        aprvalRegiYmd: this.$getGlobalDateFmt(this._.padEnd(data.aprvalRegiYmd, 20, " ")),
        aprvalMemoCtnt: data.aprvalMemoCtnt,
        lastAprvalPsnID: data.lastAprvalPsnID,
        lastPrcssStusDstcd: data.lastPrcssStusDstcd, //최종처리상태구분코드
        errMsg: data.errMsg,
        iBTelgmPrcssRsultCd: data.iBTelgmPrcssRsultCd,
        trsaccSndbakResnCtnt: data.trsaccSndbakResnCtnt,
        aprvalStgeDstcd: data.aprvalStgeDstcd,
        prcssFnshYMS: data.prcssFnshYMS,
        regiWWWBnkgLginID: data.regiWWWBnkgLginID,
        errMsgCtnt: data.errMsgCtnt,
        finalAprvalId: "0",
        printBtn,
        cancelBtn,
        approvalBtn,
        returnBtn,
        list: tmp,
      };
      //this.$set(this.RCA040DA40Res, "list", tmp); //결재선목록
      this.RCA040DA40Response = RCA040DA40Res; //store 저장
    },
  },
};

/**
 * 결재 상신
 */
export const approvalCertification = {
  computed: {
    ...mapFields("common/supplCertn", ["bizPayload"]),
  },
  methods: {
    approvalCertification(param, suc) {
      if (_.isEmpty(param.inItem)) {
        let params = {
          aprvalDstic: "0",
          ...param,
        };

        this.$post("/customer/common/ApprovalAuthorization", params, suc, function() {});
        this.$log.info(params);
      } else {
        let inItem = _.map(param.inItem, v => {
          return { inItem: v };
        });

        let params = {
          aprvalDstic: "0",
          corpBzwkCd: param.corpBzwkCd,
          inItem: inItem,
          //추가인증
          commAuth: param.commAuth,
        };
        this.$log.info(params);
        this.$post("/customer/common/ApprovalAuthorizationMulti", params, suc, function() {});
      }
    },
  },
};
